<template>
    <div class="clock-icon">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 79.9 93.22" style="enable-background:new 0 0 79.9 93.22;" xml:space="preserve">

            <g>
                <polyline class="st0" points="29.99,20.03 29.99,11.11 44.31,11.11 44.31,20.03 	"/>
                <polyline class="st0" points="9.52,34.71 3.38,28.57 13.6,18.36 19.74,24.5 	"/>
                <rect x="24.91" y="3.98" class="st0" width="24.28" height="7.13"/>
                <path class="st0" d="M63.11,30.76c7.76,5.95,12.76,15.32,12.76,25.86c0,17.99-14.58,32.57-32.57,32.57
                    c-10.49,0-19.83-4.96-25.78-12.67"/>
                <circle class="st0" cx="37.94" cy="51.43" r="32.57"/>
                <polyline class="st1" points="37.94,31.11 37.94,51.43 52.26,64.19 	"/>
            </g>
        </svg>
    </div>
</template>

<script>

export default {
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
        // console.log('Colors: ', this.colors)
    }       
}
</script>

<style lang="scss" scoped>
	.st0{fill:#FFFFFF;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}
	.st1{fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}
</style>
